
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'PerformanceScore_KPS',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/PerformanceScore_KPS.vue